"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var CompareVersionsComponent = /** @class */ (function () {
    function CompareVersionsComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._isPopup = false;
    }
    Object.defineProperty(CompareVersionsComponent.prototype, "isPopup", {
        get: function () {
            return this._isPopup;
        },
        set: function (value) {
            this._isPopup = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompareVersionsComponent.prototype, "title", {
        get: function () {
            if (this.data.title != null) {
                return this.data.title;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    CompareVersionsComponent.prototype.ngOnInit = function () {
    };
    CompareVersionsComponent.prototype.closeAction = function () {
        if (this.isPopup)
            this.dialogRef.closeAll();
    };
    return CompareVersionsComponent;
}());
exports.CompareVersionsComponent = CompareVersionsComponent;
var CompareVersionsPageComponent = /** @class */ (function () {
    function CompareVersionsPageComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this._isPopup = false;
    }
    Object.defineProperty(CompareVersionsPageComponent.prototype, "isPopup", {
        get: function () {
            return this._isPopup;
        },
        set: function (value) {
            this._isPopup = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompareVersionsPageComponent.prototype, "title", {
        get: function () {
            return "";
        },
        enumerable: true,
        configurable: true
    });
    CompareVersionsPageComponent.prototype.closeAction = function () { };
    CompareVersionsPageComponent.prototype.ngOnInit = function () {
    };
    return CompareVersionsPageComponent;
}());
exports.CompareVersionsPageComponent = CompareVersionsPageComponent;
